export enum Interest {
    Offers = 'offers',
    General = 'general',
    MarketingConsent = 'marketing_consent',
}
